import { FormFieldWrapper, WrappedInputProps } from '@/common/components/Form/FormFieldWrapper.tsx'
import React, { useCallback } from 'react'
import { useController, useWatch } from 'react-hook-form'
import { cn } from '@/utils/style.ts'
import { InputNumber, Space } from 'antd'
import { useFormSection } from '@/common/components/Form/useFormSection.tsx'

type FormNumberInput2Props = {
  placeholder?: string
  disabled?: boolean
  variant?: 'default' | 'percent'
  addonAfter?: React.ReactNode
  addonBefore?: React.ReactNode
  noSeparator?: boolean
} & WrappedInputProps

export const FormNumberInput2: React.FC<FormNumberInput2Props> = ({
  name,
  label,
  description,
  placeholder,
  className,
  wrapperClassName,
  disabled,
  variant = 'default',
  noSeparator = false,
}) => {
  const { fieldName } = useFormSection(name)
  const { field } = useController({ name: fieldName })
  const value = useWatch({ name: fieldName })


  const addonAfter = variant === 'percent' ? '%' : undefined

  const parserIn = useCallback((x?: number | null) => {
    if (x === undefined || x === null) {
      return ''
    }
    if (variant === 'percent') {
      return parseFloat((x * 100).toFixed(6)).toString()
    }
    return x.toString()
  }, [variant])

  const parserOut = useCallback((x: number | null) => {
    if (x === null) {
      return undefined
    }
    if (variant === 'percent') {
      return (x / 100).toString()
    }
    return x
  }, [variant])

  const onChange = (value: string | number | null) => {
    field.onChange(parserOut(value as (number | null)))
  }

  return (
    <FormFieldWrapper
      className={wrapperClassName}
      name={name}
      label={label}
      disabled={disabled}
      description={description}
    >
      <Space.Compact className="w-full">
        {addonAfter}
        <InputNumber
          className={cn('w-full', className)}
          size="middle"
          placeholder={placeholder}
          formatter={(value = '') => noSeparator ? value : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={(value = '') => noSeparator ? value : value!.replace(/\$\s?|(,*)/g, '')}
          value={parserIn(value)}
          onChange={onChange}
          disabled={disabled}
        />
      </Space.Compact>
    </FormFieldWrapper>
  )
}